/**
 * LazyPageFallbacks — what a lazily loaded page shows when its code cannot be
 * fetched, instead of the old silent whole-screen reload (REVIEW-2).
 *
 * - `NewVersionPage`: a newer build is live and this tab's copy of the page is
 *   gone from the server. Nothing was lost; Refresh opens the new version.
 * - `PageLoadFailedPage`: the file failed for another reason (a network blip
 *   that survived one retry). Honest, calm, one action (Design System 2.0's
 *   failed state: what failed, nothing lost, Try again).
 */
import React from 'react';
import { HubEmptyState } from '../hub/HubEmptyState';

export function NewVersionPage(): React.ReactElement {
  return (
    <HubEmptyState
      variant="page"
      kicker="New version"
      title="A new version of the app is ready"
      body="This page changed in the latest update. Nothing you were doing is lost; refresh to open the new version."
      action={{ label: 'Refresh', onClick: () => window.location.reload() }}
    />
  );
}

export function PageLoadFailedPage(): React.ReactElement {
  return (
    <HubEmptyState
      variant="page"
      kicker="Couldn't open this page"
      title="This page didn't load"
      body="Nothing was lost. It's usually the connection."
      action={{ label: 'Try again', onClick: () => window.location.reload() }}
    />
  );
}
